import anniversaryMain from "../assets/post-images/aniversary/aniversary1.jpg";
import anniversaryGallery2 from "../assets/post-images/aniversary/aniversary2.jpg";
import anniversaryGallery3 from "../assets/post-images/aniversary/aniversary3.jpg";
import anniversaryGallery4 from "../assets/post-images/aniversary/aniversary4.jpg";
import anniversaryGallery5 from "../assets/post-images/aniversary/aniversary5.jpg";
import pensioMain from "../assets/post-images/pensio/pensio10.jpg";
import pensio1 from "../assets/post-images/pensio/pensio1.jpg";
import pensio2 from "../assets/post-images/pensio/pensio2.jpg";
import pensio3 from "../assets/post-images/pensio/pensio3.jpg";
import pensio4 from "../assets/post-images/pensio/pensio4.jpg";
import pensio5 from "../assets/post-images/pensio/pensio5.jpg";
import pensio6 from "../assets/post-images/pensio/pensio6.jpg";
import pensio7 from "../assets/post-images/pensio/pensio7.jpg";
import pensio8 from "../assets/post-images/pensio/pensio8.jpg";
import pensio9 from "../assets/post-images/pensio/pensio9.jpg";
import pensio11 from "../assets/post-images/pensio/pensio11.jpg";
import socioHeroOne from "../assets/post-images/socio/socio1.jpg";
import socioHeroTwo from "../assets/post-images/socio/socio4.jpg";
import socioGallery1 from "../assets/post-images/socio/socio2.jpg";
import socioGallery2 from "../assets/post-images/socio/socio3.jpg";
import socioGallery3 from "../assets/post-images/socio/socio5.jpg";
import socioGallery4 from "../assets/post-images/socio/socio6.jpg";
import socioGallery5 from "../assets/post-images/socio/socio7.jpg";
import socioGallery6 from "../assets/post-images/socio/socio8.jpg";
import socioGallery7 from "../assets/post-images/socio/socio9.jpg";
import socioGallery8 from "../assets/post-images/socio/socio10.jpg";
import socioGallery9 from "../assets/post-images/socio/socio11.jpg";
import socioGallery10 from "../assets/post-images/socio/socio12.jpg";
import authorHero from "../assets/post-images/avtorot/avtor1.jpg";
import authorGallery2 from "../assets/post-images/avtorot/avtor2.jpg";
import authorGallery3 from "../assets/post-images/avtorot/avtor3.jpg";
import authorGallery4 from "../assets/post-images/avtorot/avtor4.jpg";
import authorGallery5 from "../assets/post-images/avtorot/avtor5.jpg";
import authorGallery6 from "../assets/post-images/avtorot/avtor6.jpg";
import authorGallery7 from "../assets/post-images/avtorot/avtor7.jpg";
import authorGallery8 from "../assets/post-images/avtorot/avtor8.jpg";
import authorGallery9 from "../assets/post-images/avtorot/avtor9.jpg";
import authorGallery10 from "../assets/post-images/avtorot/avtor10.jpg";
import authorGallery11 from "../assets/post-images/avtorot/avtor11.jpg";
import santaHero from "../assets/post-images/santa/santa1.jpg";
import santaGallery2 from "../assets/post-images/santa/santa2.jpg";
import santaGallery3 from "../assets/post-images/santa/santa3.jpg";
import santaGallery4 from "../assets/post-images/santa/santa4.jpg";
import santaGallery5 from "../assets/post-images/santa/santa5.jpg";
import santaGallery6 from "../assets/post-images/santa/santa6.jpg";
import santaGallery7 from "../assets/post-images/santa/santa7.jpg";
import santaGallery8 from "../assets/post-images/santa/santa8.jpg";
import santaDedo1 from "../assets/post-images/santa/dedo1.jpg";
import santaDedo2 from "../assets/post-images/santa/dedo2.jpg";
import santaDedo3 from "../assets/post-images/santa/dedo3.jpg";
import santaDedo4 from "../assets/post-images/santa/dedo4.jpg";
import santaDedo5 from "../assets/post-images/santa/dedo5.jpg";
import santaDedo6 from "../assets/post-images/santa/dedo6.jpg";
import santaDedo7 from "../assets/post-images/santa/dedo7.jpg";
import libraryHero from "../assets/post-images/knigata/knigata.jpg";
import libraryGallery1 from "../assets/post-images/knigata/knigata1.jpg";
import libraryGallery2 from "../assets/post-images/knigata/knigata2.jpg";
import libraryGallery3 from "../assets/post-images/knigata/knigata3.jpg";
import libraryGallery4 from "../assets/post-images/knigata/knigata4.jpg";
import libraryGallery5 from "../assets/post-images/knigata/knigata5.jpg";
import libraryGallery6 from "../assets/post-images/knigata/knigata6.jpg";
import libraryGallery7 from "../assets/post-images/knigata/knigata7.jpg";
import libraryGallery8 from "../assets/post-images/knigata/knigata8.jpg";
import libraryGallery9 from "../assets/post-images/knigata/knigata9.jpg";

const posts = [
  {
    slug: "senior-needs-forum-2025",
    date: "2025-03-26",
    author: "Anisija & Socio",
    mainImage: {
      src: socioGallery8,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: socioGallery6, alt: { mk: "", en: "" } },
      { src: socioGallery7, alt: { mk: "", en: "" } },
      { src: socioGallery9, alt: { mk: "", en: "" } },
      { src: socioGallery10, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "Форум за потребите на старите лица во Гостивар",
        excerpt:
          "В рамки на проектот „Локална иницијатива за подобрување на социјалните услуги за старите лица“ се одржа форум со презентација на анкетните наоди и дискусија со локалните актери.",
        content: [
          "Во рамките на проектот „Локална иницијатива за подобрување на социјалните услуги за старите лица“ се одржа форум на кој беа презентирани резултатите од анкетирањето на потребите на старите лица во Општина Гостивар. На настанот присуствуваа претставници од здруженијата на пензионери и инвалидни пензионери, Црвениот крст, Центарот за социјална работа, здравствениот сектор, независни пензионери и други заинтересирани граѓани.",
          "По презентацијата се отвори дискусија за приоритетите, можностите за поддршка и конкретните чекори со кои може да се унапредат услугите за старите лица во општината. Размената на искуства и предлози ги постави темелите за понатамошно институционално и граѓанско партнерство.",
          "Форумот го реализираа ЗКСО „Анисја“ и Здружението за обезбедување социјални услуги СОЦИО Гостивар, како дел од заедничките напори за создавање системски решенија за достоинствено и активно стареење.",
        ],
      },
      en: {
        title: "Forum on Senior Needs in Gostivar",
        excerpt:
          "Within the project “Local Initiative for Improving Social Services for Older Adults”, a forum presented survey findings and opened a dialogue with local stakeholders.",
        content: [
          "As part of the project “Local Initiative for Improving Social Services for Older Adults”, a forum was organised to present the survey results on the needs of seniors in the Municipality of Gostivar. Representatives from pensioner associations, the Red Cross, the Centre for Social Work, the health sector, independent pensioners, and other interested citizens took part.",
          "Following the presentation, participants discussed priorities, avenues of support, and practical steps that can enhance services for older adults in the municipality. The exchange of experiences and ideas laid the groundwork for deeper institutional and civic cooperation.",
          "The forum was delivered by ZKSO Anisija and the Association for Social Services Socio Gostivar, continuing their joint efforts to build systemic solutions for dignified and active ageing.",
        ],
      },
    },
  },
  {
    slug: "priority-agenda-for-seniors",
    date: "2025-06-13",
    author: "Anisija & Socio",
    mainImage: {
      src: socioHeroOne,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: socioGallery1, alt: { mk: "", en: "" } },
      { src: socioGallery2, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "Пензионерите и НВО секторот ги истакнаа приоритетите до Општина Гостивар",
        excerpt:
          "Пензионерските здруженија и граѓанските организации ги доставија своите клучни барања до градоначалникот Валбон Лимани за подобар живот на старите лица.",
        content: [
          "Здруженијата на пензионери и граѓанските организации во Гостивар ги презентираа своите приоритети пред градоначалникот Валбон Лимани, со акцент на подобрување на условите за старите лица. Барањата ја опфаќаат потребата од отворање дневен клуб со информативен центар за пензионери, формирање Совет на стари лица во рамки на општината, прилагодување на урбаната инфраструктура и финансиска поддршка за организирање екскурзии.",
          "Градоначалникот го информираше присутното граѓанско општество за активностите на локалната самоуправа во делот на инфраструктурата и се заложи за поддршка на иницијативите на старите лица. Овој исчекор претставува значајна основа за подобрување на квалитетот на живот во нашата општина.",
          "Процесот на дефинирање приоритети го водеше Здружението за обезбедување социјални услуги СОЦИО Гостивар во партнерство со Здружението за култура, спорт и образование „Анисија“, во рамки на проектот „Локална иницијатива за подобрување на социјалните услуги на старите лица“, субгрант на проектот „ЕУ поддршка за Граѓански ресурсен центар – фаза 2“ финансиран од Европската Унија.",
        ],
      },
      en: {
        title: "Key Priorities for Seniors Presented to the Municipality of Gostivar",
        excerpt:
          "Pensioners’ associations and civic organisations outlined priority demands to Mayor Valbon Limani to improve services and quality of life for older adults.",
        content: [
          "Pensioner associations and civil society groups in Gostivar presented their top priorities to Mayor Valbon Limani, focusing on better conditions for seniors. The platform calls for opening a day centre with an information hub, establishing a municipal council for older adults, improving age-friendly infrastructure, and providing financial support for at least one annual excursion.",
          "The Mayor shared ongoing municipal efforts to upgrade infrastructure and expressed readiness to support the initiatives coming from senior citizens. This milestone represents an important step toward enhancing the quality of life for pensioners across the municipality.",
          "The priority-setting process was led by the Association for Provision of Social Services Socio Gostivar in partnership with the Association for Culture, Sports and Education Anisija, within the project “Local Initiative for Improving Social Services for Older Adults”, a subgrant of the EU-funded project “EU Support for the Civil Resource Centre – Phase 2”.",
        ],
      },
    },
  },
  {
    slug: "consultation-on-senior-services",
    date: "2025-04-28",
    author: "Anisija & Socio",
    mainImage: {
      src: socioHeroTwo,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: socioGallery3, alt: { mk: "", en: "" } },
      { src: socioGallery4, alt: { mk: "", en: "" } },
      { src: socioGallery5, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "Консултации со старите лица во рамки на локалната иницијатива",
        excerpt:
          "На 24 април се одржа консултативен состанок во Граѓанскиот ресурсен центар во Гостивар за дефинирање на приоритетите на старите лица.",
        content: [
          "На 24 април, во Граѓанскиот ресурсен центар во Гостивар се одржа консултативен состанок со старите лица, во рамки на проектот „Локална иницијатива за подобрување на социјалните услуги за старите лица“, реализиран заедно со партнерите од „Анисија“.",
          "На состанокот се дискутираа препораките и заклучоците од извештајот за мапирање на потребите. Учесниците истакнаа потреба од проширување на услугите за нега во домот во урбани и рурални средини, поддршка на пензионерските здруженија со простор и логистика, создавање можности за социјализација и активности за активно стареење, како и подобрување на пристапноста и инфраструктурата во општината.",
          "Консултативниот процес претставува клучен чекор кон изработка на сеопфатен документ за јавни политики што ги опфаќа реалните потреби и предизвици на старите лица во Општина Гостивар.",
        ],
      },
      en: {
        title: "Consultative Meeting on Senior Services",
        excerpt:
          "On 24 April a consultative session was held at the Gostivar Civil Resource Centre to refine priorities for improving social services for seniors.",
        content: [
          "On 24 April, the Civil Resource Centre in Gostivar hosted a consultative meeting with older citizens within the project “Local Initiative for Improving Social Services for Older Adults”, delivered together with our partners from Anisija.",
          "Participants reviewed the recommendations and conclusions from the needs-mapping report. Priorities highlighted included expanding home-care services tailored for both urban and rural areas, providing space and logistics for pensioners’ associations, creating socialisation hubs and active ageing programmes, and improving accessibility and infrastructure across the municipality.",
          "This consultation is a key step toward drafting a comprehensive public policy document that reflects the real needs and challenges faced by older adults in the Municipality of Gostivar.",
        ],
      },
    },
  },
  {
    slug: "enjoy-and-donate-2023",
    date: "2023-12-24",
    author: "Anisija Team",
    mainImage: {
      src: santaHero,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: santaGallery2, alt: { mk: "", en: "" } },
      { src: santaGallery3, alt: { mk: "", en: "" } },
      { src: santaGallery4, alt: { mk: "", en: "" } },
      { src: santaGallery5, alt: { mk: "", en: "" } },
      { src: santaGallery6, alt: { mk: "", en: "" } },
      { src: santaGallery7, alt: { mk: "", en: "" } },
      { src: santaGallery8, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "„Уживај и донирај – насмевка за сите“",
        excerpt:
          "На 22–24 декември 2023 на градскиот плоштад во Гостивар се одржа третото издание на предновогодишниот хуманитарен хепенинг на ЗКСО „Анисија“.",
        content: [
          "На 22, 23 и 24 декември 2023 година, од 11 до 15 часот, на градскиот плоштад во Гостивар традиционално се одржа предновогодишниот хуманитарен хепенинг што по трет пат го организира ЗКСО „Анисија“. Настанот го водеше нашиот Дедо Мраз Марио Василески, во придружба на ученичките Антонија Новаковска, Анастасија Гиноска, Ивана Митреска и Ангела Наумовска од ООУ „Гоце Делчев“.",
          "Како и секоја година, дечињата од ЈУГД „Детска радост“ изработија и донираа новогодишни честитки, а учениците од ООУ „Гоце Делчев“ и ООУ „Мустафа Кемал Ататурк“ се приклучија со свои креации. Децата и граѓаните имаа можност да се фотографираат со Дедо Мраз, да донираат, и за возврат да земат изработка како спомен.",
          "Хепенингот го посетија бројни граѓани од сите возрасти и националности. Насмевките на посетителите и децата го претворија настанот во празнична магија со хумана цел. Собраните 18.000 денари беа донирани за лекување на дете во странство.",
          "Задоволството беше големо кај децата учесници, посетителите и нас организаторите. Со мотото „Уживај и донирај – насмевка за сите“, настанот ги мотивира помладите генерации да бидат хумани, да донираат и да ширaт насмевки. Благодарност упатуваме до основоположниците на хепенингот, меѓу кои Ива Крајоска, Ана Марија Исајлоска и Искра Д., кои ја пренесоа позитивната енергија и ја поттикнаа традицијата да продолжи.",
        ],
      },
      en: {
        title: "“Enjoy and Donate – A Smile for Everyone”",
        excerpt:
          "From 22–24 December 2023 the Gostivar city square hosted the third annual pre-New Year humanitarian happening organised by Anisija.",
        content: [
          "On 22, 23, and 24 December 2023, between 11:00 and 15:00, the city square in Gostivar welcomed the third edition of Anisija’s pre-New Year humanitarian happening. Our Santa Claus, Mario Vasilevski, was joined by pupils Antonia Novakoska, Anastasija Ginoska, Ivana Mitreska, and Angela Naumovska from Goce Delchev Primary School.",
          "Children from the public kindergarten “Detksa Radost” donated handmade holiday cards created with their educators, while students from Goce Delchev and Mustafa Kemal Atatürk primary schools contributed their crafts. Visitors could take photos with Santa, make a donation, and take home a handmade keepsake.",
          "The event drew citizens of all ages and backgrounds, filling the square with smiles and festive spirit. A total of 18,000 denars was raised and donated to support medical treatment for a child abroad.",
          "The joy was shared by participating children, visitors, and us as organisers. Under the motto “Enjoy and Donate – A Smile for Everyone”, the happening encourages younger generations to embrace humanitarian values, learn to donate, and bring smiles to others. We extend thanks to some of the founders of this tradition, including Iva Krajoska, Ana Marija Isajloska, and Iskra D., who passed their positive energy on to the younger participants.",
        ],
      },
    },
  },
  {
    slug: "library-window-to-the-world",
    date: "2023-12-15",
    author: "Anisija Team",
    mainImage: {
      src: libraryHero,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: libraryGallery1, alt: { mk: "", en: "" } },
      { src: libraryGallery2, alt: { mk: "", en: "" } },
      { src: libraryGallery3, alt: { mk: "", en: "" } },
      { src: libraryGallery4, alt: { mk: "", en: "" } },
      { src: libraryGallery5, alt: { mk: "", en: "" } },
      { src: libraryGallery6, alt: { mk: "", en: "" } },
      { src: libraryGallery7, alt: { mk: "", en: "" } },
      { src: libraryGallery8, alt: { mk: "", en: "" } },
      { src: libraryGallery9, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "„Библиотеката – прозорец кон светот“",
        excerpt:
          "На 15 декември 2023 во ООУ „Мустафа Кемал Ататурк“ се одржа едукативна работилница за важноста на книгите и библиотеките на македонски, турски и албански јазик.",
        content: [
          "На 15.12.2023 година во основното училиште „Мустафа Кемал Ататурк“ се реализираше едукативната работилница „Библиотеката – прозорец кон светот“. Учесници беа ученици од петто до деветто одделение на сите три наставни јазици – македонски, турски и албански.",
          "Децата имаа можност да слушнат и практично да се запознаат со вредноста на пишаниот збор, улогата на книгите и библиотеките, и на тој начин да развијат љубов кон читањето и знаењето.",
          "На учениците им беа поделени флаери, училишен прибор и по една книга на сите три јазици. Работилницата ја водеше советник библиотекарот Елизабета Трпчевска Петрушевска.",
          "Настанот беше поддржан од Министерството за култура на Република Северна Македонија, како дел од напорите за промовирање на читањето и културната писменост кај младите.",
        ],
      },
      en: {
        title: "“The Library – A Window to the World”",
        excerpt:
          "On 15 December 2023, Mustafa Kemal Atatürk Primary School hosted an educational workshop highlighting the value of books and libraries in Macedonian, Turkish, and Albanian.",
        content: [
          "On 15 December 2023, the primary school “Mustafa Kemal Atatürk” in Gostivar hosted an educational workshop titled “The Library – A Window to the World”. Pupils from grades five through nine attended in all three languages of instruction—Macedonian, Turkish, and Albanian.",
          "Participants learned about the significance of the written word and discovered the role that books and libraries play in expanding knowledge, inspiring them to embrace reading.",
          "Each student received flyers, school supplies, and a book in their language. The session was led by librarian specialist Elizabeta Trpchevska Petrushevska, who shared practical tips for exploring literature.",
          "The workshop was supported by the Ministry of Culture of the Republic of North Macedonia, reinforcing the importance of reading and cultural literacy among young people.",
        ],
      },
    },
  },
  {
    slug: "humanitarian-happening-2022",
    date: "2022-12-25",
    author: "Anisija Team",
    mainImage: {
      src: santaDedo1,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: santaDedo2, alt: { mk: "", en: "" } },
      { src: santaDedo3, alt: { mk: "", en: "" } },
      { src: santaDedo4, alt: { mk: "", en: "" } },
      { src: santaDedo5, alt: { mk: "", en: "" } },
      { src: santaDedo6, alt: { mk: "", en: "" } },
      { src: santaDedo7, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "Хуманитарен хепенинг „Уживај и донирај“ 2022",
        excerpt:
          "На 23–25 декември 2022 на плоштадот во Гостивар се одржа второто издание на хуманитарниот хепенинг со кој беа собрани 30.000 денари за лекување на две деца.",
        content: [
          "На 23, 24 и 25 декември 2022 година, од 10 до 15 часот, на градскиот плоштад во Гостивар се одржа второто издание на предновогодишниот хуманитарен хепенинг организиран од ЗКСО „Анисија“. Настанот го водеше нашиот тим со поддршка од ученици од средното техничко училиште ОСТУ Гостивар, кои три месеци вредно изработуваа новогодишни украси и накит за донаторите.",
          "Хепенингот го посетија бројни граѓани од сите националности и возрасти, вклучително и деца од дневниот центар. Насмевките на посетителите ја пренесоа празничната магија, а секој донатор носеше дома рачно изработен сувенир.",
          "Се собраа 30.000 денари кои беа наменети за лекување на две деца (по 15.000 денари) во странство. Задоволството беше големо и кај децата учесници, посетителите и организаторите, кои се надеваат дека со поддршка од младите ова случување ќе прерасне во трајна традиција.",
          "Целта на настанот е да ги научи младите на хумана работа, да донираат и да помагаат, создавајќи насмевки кај што повеќе лица. Благодарност упатуваме до учесниците Ива Крајоска, Ана Марија Исајлоска, Искра Д., Давор Ефтоски, Ружица Жекоска, Радица Стојкоска, Анастасија Јанкоска, Матеа Трпеска и Марио Василески. Фотографиите што го документираат настанот се преземени од gostivarpress.mk.",
        ],
      },
      en: {
        title: "Humanitarian Happening “Enjoy and Donate” 2022",
        excerpt:
          "From 23–25 December 2022, Gostivar’s city square hosted the second pre-New Year humanitarian happening, raising 30,000 denars for two children in need of treatment abroad.",
        content: [
          "On 23, 24, and 25 December 2022, between 10:00 and 15:00, the Gostivar city square welcomed the second edition of the pre-New Year humanitarian happening organised by Anisija. Students from the Gostivar Technical High School (OSTU) spent three months crafting holiday ornaments and jewellery for donors, who could take home one item for every contribution.",
          "Citizens of all ages and backgrounds, including children from the day centre, filled the square with festive cheer. Smiles were everywhere as visitors enjoyed the atmosphere and supported the cause.",
          "A total of 30,000 denars was collected and donated to two children (15,000 denars each) for medical treatment abroad. The event brought joy to participants, visitors, and organisers alike, reinforcing the organisers’ hope that, with the support of young volunteers, this happening will continue as a tradition.",
          "The initiative teaches younger generations about humanitarian values—how to donate, help those in need, and spread smiles. We thank contributors Iva Krajoska, Ana Marija Isajloska, Iskra D., Davor Eftoski, Ruzica Zekoska, Radica Stojkoska, Anastasija Jankoska, Matea Trpeska, and Mario Vasilevski. The photos accompanying this story are courtesy of gostivarpress.mk.",
        ],
      },
    },
  },
  {
    slug: "author-and-the-child",
    date: "2024-06-07",
    author: "Anisija Team",
    mainImage: {
      src: authorHero,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: authorGallery2, alt: { mk: "", en: "" } },
      { src: authorGallery3, alt: { mk: "", en: "" } },
      { src: authorGallery4, alt: { mk: "", en: "" } },
      { src: authorGallery5, alt: { mk: "", en: "" } },
      { src: authorGallery6, alt: { mk: "", en: "" } },
      { src: authorGallery7, alt: { mk: "", en: "" } },
      { src: authorGallery8, alt: { mk: "", en: "" } },
      { src: authorGallery9, alt: { mk: "", en: "" } },
      { src: authorGallery10, alt: { mk: "", en: "" } },
      { src: authorGallery11, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "„АВТОРОТ и ДЕТЕТО“ во ООУ „Гоце Делчев“",
        excerpt:
          "На 7 јуни 2024 во ООУ „Гоце Делчев“ – Гостивар, ЗКСО „Анисија“ го реализираше проектот „АВТОРОТ и ДЕТЕТО“ со гостување на авторот Горјан Петрески.",
        content: [
          "На 7 јуни 2024 година, во 13 часот, во основното училиште „Гоце Делчев“ – Гостивар, ЗКСО „Анисија“ го реализираше проектот „АВТОРОТ и ДЕТЕТО“. Настанот го збогати присуството на Горјан Петрески, реномиран автор на литература за деца и млади.",
          "Авторот беше пречекан со големо воодушевување од учениците, наставниот кадар и директорката. Учениците од пониските одделенија приредија свечен дочек со пригодна програма, по што учениците од седмо и осмо одделение слушнаа инспиративно предавање за творештвото на авторот, неговите почетоци и инспирацијата за неговите дела. Присутните дознаа и за сограѓанката и соученичка која ја отвара книгата на Споменка, како и за содржините на новите изданија.",
          "Учениците имаа можност одблиску да се запознаат со авторот чија литература ја читаат како задолжителна лектира, да поставуваат прашања и да се мотивираат за читање. На авторот, директорката, библиотекарката и дел од наставниот кадар им беа доделени благодарници за несебичниот придонес во образованието, а учениците добија привезоци, тетратки, пенкала и по една книга.",
        ],
      },
      en: {
        title: "“The Author and the Child” Visits OOU Goce Delchev",
        excerpt:
          "On 7 June 2024, Anisija brought the project “The Author and the Child” to Goce Delchev Primary School in Gostivar, welcoming children’s author Gorjan Petreski.",
        content: [
          "On 7 June 2024 at 13:00, the Association Anisija held the project “The Author and the Child” at Goce Delchev Primary School in Gostivar, inviting renowned children’s and youth author Gorjan Petreski.",
          "The author was warmly welcomed by pupils, staff, and the school principal. Lower-grade students prepared a special programme, after which seventh- and eighth-grade students heard an inspiring talk about Petreski’s beginnings, his inspirations, and the stories behind his books. He shared anecdotes about a local schoolmate who features in the book about Spomenka and offered teasers of upcoming titles.",
          "Students had the chance to meet the author whose works they read as part of their required reading list, ask questions, and draw inspiration to read more. Gratitude certificates were awarded to the author, the principal, the librarian, and members of the teaching staff for their contribution to education, while students received keychains, notebooks, pens, and a book each.",
        ],
      },
    },
  },
  {
    slug: "active-ageing-initiative",
    date: "2025-08-24",
    author: "Anisija & Socio",
    mainImage: {
      src: pensioMain,
      alt: {
        mk: "",
        en: "",
      },
    },
    gallery: [
      { src: pensio1, alt: { mk: "", en: "" } },
      { src: pensio2, alt: { mk: "", en: "" } },
      { src: pensio3, alt: { mk: "", en: "" } },
      { src: pensio4, alt: { mk: "", en: "" } },
      { src: pensio5, alt: { mk: "", en: "" } },
      { src: pensio6, alt: { mk: "", en: "" } },
      { src: pensio7, alt: { mk: "", en: "" } },
      { src: pensio8, alt: { mk: "", en: "" } },
      { src: pensio9, alt: { mk: "", en: "" } },
      { src: pensio11, alt: { mk: "", en: "" } },
    ],
    translations: {
      mk: {
        title: "Локална иницијатива за подобрување на услугите на старите лица",
        excerpt:
          "„Анисија“ и „Социо“ ја финализираа локалната иницијатива за подобри услуги за старите лица со отворен ден во градскиот парк.",
        content: [
          "Здружение „Анисија“ во партнерство со Здружението „Социо“ ја реализираа последната фаза од проектот „Локална иницијатива за подобрување на услугите на старите лица“ со отворен ден во градскиот парк. Проектот има за цел да ја подобри социјалната вклученост на повозрасните лица и да поттикне нови услуги и поддршка во локалната заедница.",
          "Со мапирање и анкетирање на повеќе од 100 лица, одржување форуми, консултативни состаноци и обуки, ги идентификувавме клучните потреби кои ги преточивме во јавен документ доставен до Општина Гостивар. Дел од препораките веќе се реализирани, а останатите се во активна имплементација.",
          "На отворениот ден учесниците споделија лични искуства за активно стареење, се играа социјални игри, се претставија публикации и рачни изработки, а се организираа и бесплатни мерења на крвен притисок и шеќер. Енергијата, ангажираноста и задоволството на присутните ја потврдија вредноста на заедничкиот труд.",
          "Искрена благодарност упатуваме до пензионерските друштва од Општина Гостивар и до сите учесници кои ја поддржаа иницијативата и продолжуваат да придонесуваат за достоинствено и активно стареење.",
        ],
      },
      en: {
        title: "Local Initiative for Improving Services for Older Adults",
        excerpt:
          "Anisija and Socio marked the final phase of the local initiative for better services for seniors with an open day in Gostivar’s city park.",
        content: [
          "Together with our partners from the association Socio, Anisija delivered the last phase of the project “Local Initiative for Improving Services for Older Adults” by hosting an open day in the city park. The initiative aims to strengthen the social inclusion of older residents and to launch new services and support in the local community.",
          "By mapping and surveying more than one hundred people, and by holding forums, consultation meetings, and trainings, we identified the key needs that were compiled into a public document submitted to the Municipality of Gostivar. Some of the recommendations have already been implemented while others are in progress.",
          "During the open day participants shared personal stories about active ageing, enjoyed social games, presented publications and handmade items, and received free blood-pressure and glucose screenings. Their energy and satisfaction confirmed the value of working together.",
          "We extend sincere thanks to the pensioners’ associations from the Municipality of Gostivar and to every participant who supported the initiative and continues to advocate for dignified, active ageing.",
        ],
      },
    },
  },
  {
    slug: "anniversary-celebration-2024",
    date: "2025-09-19",
    author: "Anisija Team",
    mainImage: {
      src: anniversaryMain,
      alt: {
        mk: "Групна фотографија од прославата на годишнината на Анисија",
        en: "Group photo from the Anisija anniversary celebration",
      },
    },
    gallery: [
      {
        src: anniversaryGallery2,
        alt: {
          mk: "Настап на културната програма на сцената",
          en: "Performance during the cultural programme on stage",
        },
      },
      {
        src: anniversaryGallery3,
        alt: {
          mk: "Свечено доделување признанија на партнерите",
          en: "Formal recognition certificates presented to partners",
        },
      },
      {
        src: anniversaryGallery4,
        alt: {
          mk: "Млади волонтери кои помагаат со организацијата",
          en: "Young volunteers assisting with the organisation",
        },
      },
      {
        src: anniversaryGallery5,
        alt: {
          mk: "Гости кои разгледуваат изложба со фотографии",
          en: "Guests viewing the photo exhibition",
        },
      },
    ],
    translations: {
      mk: {
        title: "10 години Анисија — Од соништа до дела",
        excerpt:
          "„Од соништа до дела“, „10 години сплотеност“ и „Заедно ја градиме приказната“ беа мотата што ја исполнија салата на нашата јубилејна прослава.",
        content: [
          "Од соништа до дела – 10 години исполнети со убави моменти и храбри чекори! Преку мотата „Од соништа до дела“, „10 години сплотеност, успеси и убави моменти“ и „Заедно ја градиме приказната“ го пренесовме духот со кој ја градевме Анисија од првиот ден.",
          "Прославата покажа колку сме пораснале: богата културно-образовна програма, интерактивни изложби и инспиративни говори кои потсетија дека секој проект е делче од поголема визија – посилна, поотворена и похумана заедница.",
          "Посебна благодарност упатуваме до нашите први ентузијасти и хуманисти кои направија храбри чекори и донесоа позитивни промени: Мате Василески, Ана Марија Исајлоска, Ива Крајоска, Марио Василески, Давор Ефтоски, Искра Дукоска, Радица Стојкоска, Анастасија Јанкоска, Ружица Жекоска, Антонија Новаковска и Анастасија.",
          "Им благодариме и на сите кои се дел од „Анисија“ – со нивната верба оваа годишнина е само почеток на нови успеси што заедно ќе ги создадеме.",
        ],
      },
      en: {
        title: "10 Years of Anisija — From Dreams to Deeds",
        excerpt:
          "“From Dreams to Deeds”, “10 Years of Unity”, and “Together We Build the Story” lit up the hall at our 10th anniversary celebration.",
        content: [
          "From dreams to deeds—ten years filled with beautiful moments and brave steps. Through the mottos “From Dreams to Deeds”, “10 Years of Unity, Success, and Joy”, and “Together We Build the Story”, we shared the spirit that has driven Anisija since day one.",
          "The celebration revealed how far we have come: a rich cultural and educational programme, interactive exhibitions, and inspiring speeches that reminded everyone each project is part of a bigger vision—a stronger, more open, and more humane community.",
          "We extend heartfelt gratitude to the first enthusiasts and humanitarians who took bold steps and brought positive change: Mate Vasilevski, Ana Marija Isajloska, Iva Krajovska, Mario Vasilevski, Davor Eftoski, Iskra Dulkoska, Radica Stojkoska, Anastasija Jankoska, Ruzica Zekoska, Antonija Novakoska, and Anastasija.",
          "Our thanks also go to everyone who is part of Anisija—your belief makes this anniversary just the beginning of many more milestones we will create together.",
        ],
      },
    },
  },
];

const DEFAULT_LANG = "mk";
const FALLBACK_LANG = "en";

const resolveTranslation = (translations, lang) => {
  if (!translations) return {};
  return (
    translations[lang] ||
    translations[FALLBACK_LANG] ||
    translations[DEFAULT_LANG] ||
    {}
  );
};

const translateImage = (image, lang) => {
  if (!image) return undefined;
  const alt =
    image.alt?.[lang] ??
    image.alt?.[FALLBACK_LANG] ??
    image.alt?.[DEFAULT_LANG] ??
    "";
  return {
    ...image,
    alt,
  };
};

const applyTranslation = (post, lang) => {
  const translation = resolveTranslation(post.translations, lang);
  const fallback = resolveTranslation(post.translations, FALLBACK_LANG);

  return {
    ...post,
    title: translation.title ?? fallback.title ?? post.slug,
    excerpt: translation.excerpt ?? fallback.excerpt ?? "",
    content: translation.content ?? fallback.content ?? [],
    mainImage: translateImage(post.mainImage, lang),
    gallery: (post.gallery || []).map((image) => translateImage(image, lang)),
  };
};

export const getPostsByLang = (lang = DEFAULT_LANG) =>
  posts.map((post) => applyTranslation(post, lang));

export const findPostBySlug = (lang, slug) => {
  const post = posts.find((item) => item.slug === slug);
  if (!post) {
    return undefined;
  }
  return applyTranslation(post, lang);
};

export default posts;
